// Quantity.js
// Component for Quantity field

// Imports
import React from 'react';
import { InputGroup } from '@blueprintjs/core';
import PropTypes from 'prop-types';

// Component Class
// Shows Quantity Field
class Quantity extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    var order = this.getOrder();
    this.state = {
      quantity: order.quantity,
      validQuantity: true,
    };
  }

  // Verifies if state is valid after an update
  componentDidUpdate (prevProps) {
    if (prevProps.order !== this.props.order) {
      var order = this.getOrder();
      this.setState({
        quantity: order.quantity,
        validQuantity: true,
      });
    }
  }
  
  // Returns the current order
  getOrder = () => {
    var order;
    if (this.props.order)
      order = this.props.order[this.props.id];

    if (!order)
      order = { quantity: "", unitId: 0 };
    return order;
  }

  // Method called when the quantity field changes
  onQuantityChange = (event) => {
    var value = Number.parseFloat(event.target.value);
    var valid = true;
    var lastChar = event.target.value.length > 0 ? event.target.value.slice(-1) : ""; 
    if (!Number.isNaN(value) && value >= 0 && lastChar !== ".") {
      this.props.setQuantity(value);
    }
    else if (event.target.value.trim() !== "")
    valid = false;
    this.setState({quantity: event.target.value, validQuantity: valid});
  }

  // Method called when the use finishes editing the quantity field
  onQuantityBlur = () => {
    if (this.state.quantity === "") {
      this.props.setQuantity(0);
      this.setState({quantity: "", validQuantity: true});
      return;
    }
    
    var order = this.getOrder();
    var value = Number.parseFloat(this.state.quantity);
    if (Number.isNaN(value) || value <= 0)
      value = order.quantity;
    this.setState({quantity: value, validQuantity: true});
  }

  // Renders Component
  render() {
    return (
      <InputGroup
        intent={this.state.validQuantity ? "":"danger"}
        style={{width: '100%'}}
        placeholder="Qtd"
        value={this.state.quantity}
        leftIcon="box"
        onChange={this.onQuantityChange}
        onBlur={this.onQuantityBlur}
      />
    );
  }
}

// Required Properties
Quantity.propTypes = {
  id: PropTypes.number.isRequired,
  order: PropTypes.object,
  setQuantity: PropTypes.func.isRequired,
}

// Exports
export default Quantity;


// WEBPACK FOOTER //
// ./src/components/OrderView/Quantity.js